import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    COMMITTEE_LIST,
    COMMITTEE_ADDEDIT,
    COMMITTEE_CHANGE_STATUS,
    COMMITTEE_GETONE,
    ALLDESIGNATION_LIST,
    ALLUSER_LIST,
    ALLDISTRICT_LIST,
    ALLTALUKA_LIST,
    ALLVILLAGE_LIST,
    COMMITTEE_DELETE,
    COMMITTEE_EXPORT
 } from "../../api/constApi";
import { 
    committeeListApi, 
    committeeChangeStatusApi, 
    AddEditCommitteeApi,
    GetoneCommitteeApi,
    committeeDeleteApi,
    GetAllDesignationApi,
    GetAllUserApi,
    GetAllDistrictApi ,
    GetAllTalukaApi,
    GetAllVillageApi,
    committeeExportApi
} from "../Services/committeService";
import { useSelector } from "react-redux";
import { useMemo } from "react";

export const committeeList = createAsyncThunk(COMMITTEE_LIST, async (payload) => {
    const response = await committeeListApi(payload);
    return response.data;
});

export const committeeChangeStatus = createAsyncThunk(COMMITTEE_CHANGE_STATUS, async (payload) => {
    const response = await committeeChangeStatusApi(payload);
    return response.data;
});

export const addEditCommittee = createAsyncThunk(COMMITTEE_ADDEDIT, async (payload) => {
    const response = await AddEditCommitteeApi(payload);
    return response.data;
});

export const getOneCommittee = createAsyncThunk(COMMITTEE_GETONE, async (payload) => {
    const response = await GetoneCommitteeApi(payload);
    return response.data;
});

export const deleteCommittee = createAsyncThunk(COMMITTEE_DELETE, async (payload) => {
    const response = await committeeDeleteApi(payload);
    return response.data;
});

export const getDesignationList = createAsyncThunk(ALLDESIGNATION_LIST, async (payload) => {
    const response = await GetAllDesignationApi(payload);
    return response.data;
});

export const getUserList = createAsyncThunk(ALLUSER_LIST, async (payload) => {
    const response = await GetAllUserApi(payload);
    return response.data;
});

export const getDistrictList = createAsyncThunk(ALLDISTRICT_LIST, async (payload) => {
    const response = await GetAllDistrictApi(payload);
    return response.data;
});

export const getTalukaList = createAsyncThunk(ALLTALUKA_LIST, async (payload) => {
    const response = await GetAllTalukaApi(payload);
    return response.data;
});

export const getVillageList = createAsyncThunk(ALLVILLAGE_LIST, async (payload) => {
    const response = await GetAllVillageApi(payload);
    return response.data;
});

export const committeeExport = createAsyncThunk(COMMITTEE_EXPORT, async (payload) => {
    const response = await committeeExportApi(payload);
    return response.data;
});

export const committeeSlice = createSlice({
    name: "committee",
    initialState: {
        committee: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(committeeList.fulfilled, (state, action) => {
            state.committee = action?.payload;
        });
        builder.addCase(addEditCommittee.fulfilled, (state, action) => {
            state.committee = action?.payload?.Data;
          });
    }
});

export default committeeSlice.reducer;

// villagelist selector
export const selectCommitteeList = (state) => state?.committee?.committee;
export const useCommitteeList = () => {
  const committee = useSelector(selectCommitteeList);
  return useMemo(() => committee, [committee]);
};